import React from 'react';

const Icon = ({ type, className = '', style = {}, onClick }) => {
  return (
    <i 
      className={`iconfont icon-${type} ${className}`} 
      style={style}
      onClick={onClick}
    />
  );
};

export default Icon;
